import { usePlan } from "@/features/auth";
import type { ChatVersion } from "@/features/chat/types";

/**
 * Resolve the active chat backend for the current organization.
 *
 * `service_chat` (Chat v2 / rooms API) takes precedence when both flags are
 * set so an org migrated to v2 cannot accidentally fall back to legacy.
 * Defaults to "modern" when no flag is set — the legacy `/channels` API is
 * an explicit opt-in.
 */
export const useChatVersion = (): ChatVersion => {
  const plan = usePlan();
  if (plan?.features.service_chat) return "modern";
  if (plan?.features.service_chat_legacy) return "legacy";
  return "modern";
};
